module.exports = {"TXTWCL_Popular_Sports":{"id":"TXTWCL_Popular_Sports","defaultMessage":"Popular Sports"}}